export default __webpack_public_path__ + "static/media/Amended Articles of Incorporation.f6bba200.pdf";